import { Draft } from 'immer';
import { getType } from 'typesafe-actions';

import { CanvasAction } from '../../common/actions';
import {
    changeOptionsOverlayColor,
    closeLongUploadPopup,
    hidePreviewLoading,
    initVideoData,
    openLongUploadPopup,
    setPcodePreviewData,
    showPreviewLoading
} from '../actions';
import {
    selectCreativeOptionGroupValue,
    selectCreativeOptions,
    selectVideoCreativeState,
    selectVideoOrOverlayCreativeState
} from '../selectors';
import { AddCreativeState } from '../typings';

import { getOptionsDependingOnVideoColor, getVideoPcodePreviewData } from './helpers';

export function processAddVideoCreative(draft: Draft<AddCreativeState>, action: CanvasAction): void {
    switch (action.type) {
        case getType(setPcodePreviewData): {
            const videoCreativeState = selectVideoOrOverlayCreativeState(draft);
            videoCreativeState.pcodeVideoPreviewData = getVideoPcodePreviewData(action.vast);

            return;
        }

        case getType(closeLongUploadPopup): {
            const videoCreativeState = selectVideoCreativeState(draft);
            videoCreativeState.longUploadPopupVisible = false;
            videoCreativeState.createButtonPressed = true;

            return;
        }

        case getType(openLongUploadPopup): {
            const videoCreativeState = selectVideoCreativeState(draft);

            videoCreativeState.longUploadPopupVisible = true;

            return;
        }

        case getType(showPreviewLoading): {
            const videoCreativeState = selectVideoOrOverlayCreativeState(draft);
            videoCreativeState.isPreviewLoading = true;

            return;
        }

        case getType(hidePreviewLoading): {
            const videoCreativeState = selectVideoOrOverlayCreativeState(draft);
            videoCreativeState.isPreviewLoading = false;
            videoCreativeState.isSaving = false;

            return;
        }

        case getType(changeOptionsOverlayColor): {
            const creativeOptions = selectCreativeOptions(draft);

            const options = getOptionsDependingOnVideoColor(creativeOptions.optionsConfig);
            options.forEach(option => {
                const groupValue = selectCreativeOptionGroupValue(creativeOptions, option.groupName);

                groupValue.options[option.name] = action.overlayColor;
            });

            return;
        }

        case getType(initVideoData): {
            const videoCreativeState = selectVideoCreativeState(draft);
            videoCreativeState.videoPreviewData = action.videoPreviewData;

            return;
        }

        default:
            return;
    }
}
